<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2024-05-08 14:21:15
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-05-16 10:02:45
-->
<template>
  <div class="applicationLogin">
    <div class="header">
      <div class="c-1200">
        <div class="logo">
          <!-- <img src="../../assets/exam/login_logo.png" alt="" /> -->
          <span>职业技能等级考试系统</span>
        </div>
        <div class="port">考生端</div>
      </div>
    </div>
    <div class="login_main">
      <div class="c-1200">
        <div class="wel">
          <h3>
            <p>欢迎登录</p>
            <p>职业技能等级考试系统</p>
          </h3>
        </div>
        <div class="login-card">
          <div class="title">学员报名资料</div>
          <div class="form">
            <el-input
              v-model="idCard"
              placeholder="请输入身份证号码"
            ></el-input>
            <el-popover
              v-model="sliderVisible"
              placement="right"
              width="310"
              trigger="manual"
            >
              <slide-verify
                :l="42"
                :r="10"
                :w="310"
                :h="155"
                :imgs="sliderImgList"
                slider-text="向右滑动"
                @success="onSuccess"
                @fail="onFail"
                @refresh="onRefresh"
              ></slide-verify>
              <el-button
                plain
                :type="sliderOk ? 'success' : ''"
                :icon="sliderOk ? 'el-icon-circle-check' : ''"
                slot="reference"
                @click="handleSliderBtnClick"
                >{{ sliderOk ? "验证成功" : "点击完成验证" }}</el-button
              >
            </el-popover>
            <div class="btn" @click="login">登 录</div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">copyright©2022湖北长江互联网教育研究院出品</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliderImgList: [
        require("@/assets/slider_1.png"),
        require("@/assets/slider_2.png"),
        require("@/assets/slider_3.png"),
        require("@/assets/slider_4.png"),
      ],
      sliderOk: false,
      sliderVisible: false,
      idCard: "",
    };
  },
  methods: {
    async login() {
      if (!this.idCard) return this.$message.warning("请填写身份证");
      if (!this.sliderOk) return this.$message.warning("请先完成验证");
      this.$router.push({
        path: "/application/list",
        query: {
          idCard: this.idCard,
        },
      });
    },
    handleSliderBtnClick() {
      if (!this.sliderOk) {
        this.sliderVisible = !this.sliderVisible;
      }
    },
    onSuccess() {
      this.sliderOk = true;
      this.sliderVisible = false;
    },
    onFail() {
      console.log("验证失败");
    },
    onRefresh() {
      console.log("刷新验证码");
    },
  },
};
</script>

<style scoped lang="scss">
.applicationLogin {
  background-color: #f5f7fa;
  box-sizing: border-box;
  height: 100vh;
  .header {
    width: 100%;
    height: 70px;
    background: #ffffff;
    .c-1200 {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        display: flex;
        align-items: center;
        img {
          margin-right: 10px;
        }
        span {
          display: block;
          height: 24px;
          line-height: 22px;
          position: relative;
          font-size: 18px;
          font-weight: 500;
          color: #3671bf;
          border-left: 1px solid #c1c8d1;
          padding-left: 12px;
        }
      }
      .port {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .header {
    width: 100%;
    height: 70px;
    background: #ffffff;
    .c-1200 {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        display: flex;
        align-items: center;
        img {
          margin-right: 10px;
        }
        span {
          display: block;
          height: 24px;
          line-height: 22px;
          position: relative;
          font-size: 18px;
          font-weight: 500;
          color: #3671bf;
          border-left: 1px solid #c1c8d1;
          padding-left: 12px;
        }
      }
      .port {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .login_main {
    height: calc(100% - 70px);
    background: url("../../assets/application/login_bg.png") center;
    .c-1200 {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .wel {
      display: flex;
      flex-direction: column;
      h3 {
        font-size: 54px;
        font-weight: bold;
        color: #ffffff;
        line-height: 80px;
        margin-bottom: 117px;
      }
    }
    .login-card {
      float: right;
      text-align: center;
      box-sizing: border-box;
      width: 400px;
      height: 410px;
      background: #ffffff;
      border-radius: 8px;
      padding-top: 50px;
      .title {
        font-size: 24px;
        line-height: 24px;
        font-weight: 500;
        color: #292c33;
        margin-bottom: 45px;
      }
      .form {
        box-sizing: border-box;
        width: 400px;
        height: 327px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        padding: 0 40px;
      }
      .el-input {
        width: 100%;
        margin-bottom: 14px;
      }
      .el-button {
        width: 100%;
        margin-bottom: 46px;
        transition: all 0.3s;
      }
      .btn {
        cursor: pointer;
        width: 320px;
        height: 40px;
        background: #3882e4;
        box-shadow: 0px 4px 10px 1px #b6c5db;
        border-radius: 4px 4px 4px 4px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        color: #fff;
      }
    }
  }
  .copyright {
    position: absolute;
    bottom: 30px;
    text-align: center;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
    line-height: 14px;
  }
}
</style>
